import { userData } from '@/common/custom-date-selector-list/helpers';
import { reportCalculateTotalsLength } from '@/utils/helper/TotalCalculation';
import { align } from '@progress/kendo-drawing';
import { render } from '@react-pdf/renderer';

export const generateDynamicColumns = (
  tableData,
  excludedKeys = ['redirect_url', ''],
  allowCamelCase = false,
  columnOverrides = {},
) => {
  if (!tableData || tableData?.length === 0) return [];
  // Function to check if a string is in camelCase
  const isCamelCase = (key) => /^[a-z]+[A-Z][a-zA-Z]*$/.test(key);

  const columnConfig = {
    'S.N.': { align: 'center', textAlign: 'center', width: 50 },
    'S N': { align: 'center', textAlign: 'center' },
    Purchase: { align: 'right', width: 100, textAlign: 'right' },
    purchase: {
      title: 'Purchase',
      align: 'right',
      width: 100,
      textAlign: 'right',
    },
    'Party Name': { align: 'left', textAlign: 'left' },
    'Ref. No.': { align: 'left', textAlign: 'left' },
    ref_no: { title: 'Ref. No.', align: 'left', textAlign: 'left' },
    Date: { align: 'center', width: 80, textAlign: 'center' },
    'Issue Date': { align: 'center', width: 80, textAlign: 'center' },
    Party: { align: 'left', width: 250, textAlign: 'left' },
    party_name: {
      title: 'Party',
      align: 'left',
      width: 250,
      textAlign: 'left',
    },
    'Agent Name': { align: 'left', width: 250, textAlign: 'left' },
    agent_name: {
      title: 'Agent',
      align: 'left',
      width: 250,
      textAlign: 'left',
    },
    'Debit (Rs.)': { align: 'right', width: 100, textAlign: 'right' },
    'Credit (Rs.)': { align: 'right', width: 100, textAlign: 'right' },
    'Set or Pcs': { align: 'right', width: 100, textAlign: 'right' },
    'Gross Weight': { align: 'center', width: 100, textAlign: 'right' },
    'Net Weight': { align: 'center', width: 100, textAlign: 'right' },
    'Weight In Gram': { align: 'center', width: 100, textAlign: 'right' },
    'Diamond Weight (crt)': { align: 'center', width: 100, textAlign: 'right' },
    'Stone Weight (lal)': { align: 'center', width: 100, textAlign: 'right' },
    'Conv. (lal/gm)': { align: 'center', width: 100, textAlign: 'right' },
    'Stone Weight': { align: 'center', width: 100, textAlign: 'right' },
    'Diamond Weight': { align: 'center', width: 100, textAlign: 'right' },
    'Pure Weight': { align: 'center', width: 100, textAlign: 'right' },
    'Net Amount': { align: 'center', width: 150, textAlign: 'right' },
    'Sales Amount': { align: 'center', width: 150, textAlign: 'right' },

    'Dr Amount': { align: 'center', width: 100, textAlign: 'right' },
    'Cr Amount': { align: 'center', width: 100, textAlign: 'right' },
    'Dr Metal': { align: 'center', width: 100, textAlign: 'right' },
    'Cr Metal': { align: 'center', width: 100, textAlign: 'right' },

    'Cost Rate': { align: 'center', width: 100, textAlign: 'right' },
    MRP: { align: 'center', width: 100, textAlign: 'right' },
    'Issue Cost Amount': { align: 'center', width: 100, textAlign: 'right' },
    'Receive Profit In Wt': { align: 'center', width: 100, textAlign: 'right' },
    'Receive Sales Amount': { align: 'center', width: 100, textAlign: 'right' },
    'Receive profit %': { align: 'center', width: 100, textAlign: 'right' },
    'Receive Gw/Pw': { align: 'center', width: 100, textAlign: 'right' },
    'Issue Gross wt': { align: 'center', width: 100, textAlign: 'right' },
    'Receive Profit In Amount': {
      align: 'center',
      width: 100,
      textAlign: 'right',
    },

    'Gold Rate': { align: 'center', textAlign: 'center' },
    'Silver Rate': { align: 'center', textAlign: 'center' },

    Amount: { align: 'center', width: 100, textAlign: 'right' },
    amount: {
      title: 'Amount',
      align: 'center',
      width: 100,
      textAlign: 'right',
    },
    'Old Value': { align: 'center', width: 100, textAlign: 'right' },
    'New Value': { align: 'center', width: 100, textAlign: 'right' },
    'MRP Amount	': { align: 'left', textAlign: 'left' },
    ledger_reference_id: {
      title: 'Reference',
      align: 'left',
      width: 250,
    },
    ledger_name: { title: 'Ledger Name', align: 'left', width: 500 },
    dr_amount: {
      title: 'Dr Amount',
      textAlign: 'right',
      width: 500,
    },
    cr_amount: { title: 'Cr Amount', textAlign: 'right', width: 500 },
    dr_metal: { title: 'Dr Metal', align: 'right', width: 500 },
    cr_metal: { title: 'Cr Metal', align: 'right', width: 500 },
    parent_id: { title: 'Parent ID', align: 'left', width: 200 },
    sn: {
      title: 'S.N.',
      align: 'center',
      width: '60',
    },
    transaction_date: {
      title: 'Transaction Date',
      align: 'center',
      width: '100',
    },
    party: {
      title: 'Party',
      align: 'left',
      width: '150',
    },
    transaction_type: {
      title: 'Transaction Type',
      align: 'left',
      width: '100',
    },
    inv_no: {
      title: 'INV No.',
      align: 'center',
      width: '100',
    },
    receive_gross_weight: {
      title: 'Receive Gross Weight',
      align: 'right',
      width: '120',
    },
    issue_gross_weight: {
      title: 'Issue Gross Weight',
      align: 'right',
      width: '120',
    },
    receive_set_pcs: {
      title: 'Receive Set Or Pcs',
      align: 'right',
      width: '120',
    },
    issue_set_pcs: {
      title: 'Issue Set Or Pcs',
      align: 'right',
      width: '120',
    },
    balance_gross_weight: {
      title: 'Balance Gross Weight',
      align: 'right',
      width: '130',
    },
    balance_set_pcs: {
      title: 'Balance Set Or Pcs',
      align: 'right',
      width: '130',
    },
    // redirect_url intentionally omitted — not a visible column, used only for row-click navigation

    account_group_id: {
      title: 'Account Group ID',
      align: 'right',
      width: 200,
    },
    customer_address: {
      title: 'Address',
      align: 'left',
      width: 400,
    },
    customer_mobile_number: {
      title: 'Mobile Number',
      align: 'left',
      width: 300,
    },
    customer_pan_vat: {
      title: 'PAN/VAT',
      align: 'left',
      width: 300,
    },
    item_id: {
      title: 'Item ID',
      textAlign: 'left',
      width: 100,
    },
    item_code: {
      title: 'Code',
      align: 'left',
      width: 300,
    },
    show_item_code: {
      title: 'Code',
      align: 'left',
      width: 300,
    },
    purity: {
      title: 'Purity',
      align: 'left',
      width: 300,
    },
    total_set_pcs: {
      title: 'Set/Pcs',
      textAlign: 'right',
      width: 300,
    },
    total_gross_wt: {
      title: 'Gross Wt',
      align: 'left',
      width: 300,
    },
    total_gross_weight: {
      title: 'Gross Wt',
      align: 'left',
      width: 300,
    },
    total_net_weight: {
      title: 'Net Wt',
      align: 'left',
      width: 300,
    },
    total_pure_wt: {
      title: 'Pure Wt',
      align: 'left',
      width: 300,
    },
    total_pure_weight: {
      title: 'Pure Wt',
      align: 'left',
      width: 300,
    },
    mrp: {
      title: 'MRP',
      align: 'left',
      width: 300,
    },
    total_diamond_wt: {
      title: 'Diamond Wt',
      align: 'left',
      width: 300,
    },
    total_diamond_weight: {
      title: 'Diamond Wt',
      align: 'left',
      width: 300,
    },
    total_diamond_pcs: {
      title: 'Diamond Pcs',
      textAlign: 'right',
      width: 300,
    },
    total_stone_wt: {
      title: 'Stone Wt',
      align: 'left',
      width: 300,
    },
    total_stone_weight: {
      title: 'Stone Wt',
      align: 'left',
      width: 300,
    },
    total_stone_pcs: {
      title: 'Stone Pcs',
      textAlign: 'right',
      width: 300,
    },

    bill_no: {
      title: 'Bill No.',
      align: 'left',
      width: 300,
    },

    show_bill_no: {
      title: 'Bill No.',
      align: 'left',
    },

    entry_date: {
      title: 'Entry Date',
      align: 'left',
    },

    store_name: {
      title: 'Store',
      align: 'left',
    },

    reference_number: {
      title: 'Ref No.',
      align: 'left',
    },

    return_date: {
      title: 'Return Date',
      align: 'left',
    },

    ref_bill_no: {
      title: 'Ref. Bill No.',
      align: 'left',
    },

    sales_bill_no: {
      title: 'Sales Bill No.',
      align: 'left',
    },

    purchase_bill_no: {
      title: 'Purchase Bill No.',
      align: 'left',
    },

    entry_no: {
      title: 'Entry No.',
      align: 'left',
    },

    supplier_name: {
      title: 'Supplier Name',
      align: 'left',
    },

    supplier_phone_no: {
      title: 'Supplier Phone No.',
      align: 'left',
    },

    supplier_pan_no: {
      title: 'Supplier PAN',
      align: 'left',
    },

    total_return_amount: {
      title: 'Total Return Amount',
      textAlign: 'right',
      width: 120,
    },

    buyer_name: {
      title: `Buyer's Name`,
      align: 'left',
      width: 300,
    },

    buyer_pan_no: {
      title: `Buyer's Pan`,
      align: 'left',
      width: 300,
    },
    buyer_phone_no: {
      title: `Buyer's Phone No.`,
      align: 'left',
      width: 300,
    },
    buyer_address: {
      title: `Buyer's Address`,
      align: 'left',
      width: 300,
    },

    // isCancel: {
    //   title: 'isCancel',
    //   align: 'left',
    //   width: 300,
    // },

    non_taxable_amount: {
      title: 'Non Taxable Amount',
      textAlign: 'right',
      width: 300,
    },

    sales_date: {
      title: 'Date',
      align: 'left',
      width: 300,
    },

    // salesId: {
    //   title: 'Sales Id',
    //   align: 'left',
    //   width: 300,
    // },

    tax_amount: {
      title: 'Tax Amount',
      textAlign: 'right',
      width: 300,
    },

    taxable_amount: {
      title: 'Taxable Amount',
      textAlign: 'right',
      width: 300,
    },

    total_sales_amount: {
      title: 'Total Sales Amount',
      textAlign: 'right',
      width: 300,
    },
    weight_in_gram: {
      title: 'Weight in Gram',
      textAlign: 'right',
      width: 300,
    },
    weight_in_lal: {
      title: 'Weight In Lal',
      textAlign: 'right',
      width: 300,
    },

    vat_amount: {
      title: 'Vat Amount',
      textAlign: 'right',
      width: 300,
    },

    vatable_amount: {
      title: 'Vatable Amount',
      textAlign: 'right',
      width: 300,
    },
    purchase_date: {
      title: 'Date',
      textAlign: 'left',
    },
    net_amount: {
      title: 'Net Amount',
      textAlign: 'right',
    },

    item_name: {
      title: 'Item Name',
      textAlign: 'left',
    },

    set_pcs: {
      title: 'Set/Pcs',
      textAlign: 'right',
      width: 80,
    },
    gross_weight: {
      title: 'Gross Wt',
      textAlign: 'right',
      width: 100,
    },
    diamond_pcs: {
      title: 'Diamond Pcs',
      textAlign: 'right',
      width: 100,
    },
    diamond_weight: {
      title: 'Diamond Wt',
      textAlign: 'right',
      width: 100,
    },
    stone_pcs: {
      title: 'Stone Pcs',
      textAlign: 'right',
      width: 100,
    },
    stone_weight: {
      title: 'Stone Wt',
      textAlign: 'right',
      width: 100,
    },
    net_weight: {
      title: 'Net Wt',
      textAlign: 'right',
      width: 100,
    },
    pure_weight: {
      title: 'Pure Wt',
      textAlign: 'right',
      width: 100,
    },
    size: {
      title: 'Size',
      textAlign: 'left',
      width: 80,
    },

    voucher_date: {
      title: 'Date',
      textAlign: 'left',
    },
    voucher_type: {
      title: 'Type',
      textAlign: 'left',
    },
    voucher_number: {
      title: 'Voucher Number',
      textAlign: 'left',
    },
    vch_no: {
      title: 'Voucher Number',
      textAlign: 'left',
    },
    pay_from: {
      title: 'Pay From',
      textAlign: 'left',
    },
    pay_to: {
      title: 'Pay To',
      textAlign: 'left',
    },
    debit: {
      title: 'Debit',
      textAlign: 'right',
    },
    credit: {
      title: 'Credit',
      textAlign: 'right',
    },
    // amount: {
    //   title: 'Amount',
    //   textAlign: 'right',
    // },
    remarks: {
      title: 'Remarks',
      textAlign: 'left',
    },
    'Item Name': {
      title: 'Item Name',
      align: 'center',
      width: 250,
      textAlign: 'left',
    },
    'Item Code': {
      title: 'Item Code',
      textAlign: 'left',
    },
    Purity: {
      title: 'Purity',
      align: 'center',
      width: 100,
      textAlign: 'left',
    },
    'Set Pcs': {
      title: 'Set Pcs',
      align: 'right',
      width: 100,
      textAlign: 'right',
    },
    Gwt: {
      title: 'Gwt',
      textAlign: 'right',
    },
    'Dia. Pcs': {
      title: 'Dia. Pcs',
      textAlign: 'right',
    },
    'Dia. Wt': {
      title: 'Dia. Wt',
      textAlign: 'right',
    },
    'St. Pcs': {
      title: 'St. Pcs',
      textAlign: 'right',
    },
    'St. Wt': {
      title: 'St. Wt',
      textAlign: 'right',
    },
    'N. Wt': {
      title: 'N. Wt',
      textAlign: 'right',
    },
    'P. Wt.': {
      title: 'P. Wt.',
      textAlign: 'right',
    },
    Size: {
      title: 'Size',
      textAlign: 'left',
    },
    dr_gold: { title: 'Dr', textAlign: 'right', width: 150 },
    cr_gold: { title: 'Cr', textAlign: 'right', width: 150 },
    dr_silver: { title: 'Dr', textAlign: 'right', width: 150 },
    cr_silver: { title: 'Cr', textAlign: 'right', width: 150 },

    billNo: {
      title: 'Bill No',
      dataIndex: 'billNo',
      key: 'billNo',
    },
    orderDate: {
      title: 'Order Date',
      dataIndex: 'orderDate',
      key: 'orderDate',
    },
    partyName: {
      title: 'Party Name',
      dataIndex: 'partyName',
      key: 'partyName',
    },
    agentName: {
      title: 'Agent Name',
      dataIndex: 'agentName',
      key: 'agentName',
    },
    refNo: {
      title: 'Ref No',
      dataIndex: 'refNo',
      key: 'refNo',
    },
    netAmount: {
      title: 'Net Amount',
      dataIndex: 'netAmount',
      key: 'netAmount',
      align: 'right',
    },
    advanceAmount: {
      title: 'Advance Amount',
      dataIndex: 'advanceAmount',
      key: 'advanceAmount',
      align: 'right',
    },
    isIssue: {
      title: 'Issue',
      dataIndex: 'isIssue',
      key: 'isIssue',
    },
    transaction_date: {
      title: 'Transaction Date',
      dataIndex: 'transaction_date',
      key: 'transaction_date',
    },

    party: {
      title: 'Party',
      dataIndex: 'party',
      key: 'party',
    },

    transaction_type: {
      title: 'Transaction Type',
      dataIndex: 'transaction_type',
      key: 'transaction_type',
    },

    inv_no: {
      title: 'INV No.',
      dataIndex: 'inv_no',
      key: 'inv_no',
    },

    receive_gross_weight: {
      title: 'Receive Gross Weight',
      dataIndex: 'receive_gross_weight',
      key: 'receive_gross_weight',
      align: 'right',
    },

    issue_gross_weight: {
      title: 'Issue Gross Weight',
      dataIndex: 'issue_gross_weight',
      key: 'issue_gross_weight',
      align: 'right',
    },

    receive_set_pcs: {
      title: 'Receive Set PCS',
      dataIndex: 'receive_set_pcs',
      key: 'receive_set_pcs',
      align: 'right',
    },

    issue_set_pcs: {
      title: 'Issue Set PCS',
      dataIndex: 'issue_set_pcs',
      key: 'issue_set_pcs',
      align: 'right',
    },

    balance_gross_weight: {
      title: 'Balance Gross Weight',
      dataIndex: 'balance_gross_weight',
      key: 'balance_gross_weight',
      align: 'right',
    },

    balance_set_pcs: {
      title: 'Balance Set PCS',
      dataIndex: 'balance_set_pcs',
      key: 'balance_set_pcs',
      align: 'right',
    },
    sn: {
      title: 'S.N.',
      dataIndex: 'sn',
      key: 'sn',
      width: 70,
    },
    returnDate: {
      title: 'Date',
      dataIndex: 'returnDate',
      key: 'returnDate',
    },
    // salesReturnId: {
    //   title: 'Sales Return ID',
    //   dataIndex: 'salesReturnId',
    //   key: 'salesReturnId',
    // },
    billNo: {
      title: 'Bill No',
      dataIndex: 'billNo',
      key: 'billNo',
    },
    entryNo: {
      title: 'Entry No',
      dataIndex: 'entryNo',
      key: 'entryNo',
    },
    partyName: {
      title: 'Party Name',
      dataIndex: 'partyName',
      key: 'partyName',
    },
    amount: {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      textAlign: 'right',
    },
    salesDate: {
      title: 'Date',
      dataIndex: 'salesDate',
      key: 'salesDate',
      align: 'right',
      textAlign: 'right',
    },
    billNumber: {
      title: 'Bill Number',
      dataIndex: 'billNumber',
      key: 'billNumber',
      align: 'right',
      textAlign: 'right',
    },
    displayBillNumber: {
      title: 'Bill Number',
      dataIndex: 'displayBillNumber',
      key: 'displayBillNumber',
      align: 'right',
      textAlign: 'right',
    },
    ReferenceNumber: {
      title: 'Reference Number',
      dataIndex: 'ReferenceNumber',
      key: 'ReferenceNumber',
    },
    storeName: {
      title: 'Store',
      align: 'left',
      textAlign: 'left',
    },
    s_n: {
      title: 'S.N.',
      textAlign: 'center',
      width: 70,
    },

    gwt: {
      title: 'Gwt',
      textAlign: 'right',
      width: 100,
    },

    dia_pcs: {
      title: 'Dia. Pcs',
      textAlign: 'right',
      width: 100,
    },

    dia_wt: {
      title: 'Dia. Wt',
      textAlign: 'right',
      width: 100,
    },

    dia_amt: {
      title: 'Dia. Amt',
      textAlign: 'right',
      width: 100,
    },

    st_pcs: {
      title: 'St. Pcs',
      textAlign: 'right',
      width: 100,
    },

    st_wt: {
      title: 'St. Wt',
      textAlign: 'right',
      width: 100,
    },

    st_amt: {
      title: 'St. Amt',
      textAlign: 'right',
      width: 100,
    },

    n_wt: {
      title: 'N. Wt',
      textAlign: 'right',
      width: 100,
    },

    wast_wt: {
      title: 'Wastage Wt',
      textAlign: 'right',
      width: 100,
    },

    m_amt: {
      title: 'M. Amt',
      textAlign: 'right',
      width: 100,
    },

    p_wt: {
      title: 'P. Wt.',
      textAlign: 'right',
      width: 100,
    },

    extra: {
      title: 'Extra',
      textAlign: 'right',
      width: 100,
    },

    discount: {
      title: 'Discount',
      textAlign: 'right',
      width: 100,
    },

    receive_weight: {
      title: 'Receive Weight',
      textAlign: 'right',
      width: 120,
    },
  };
  const columnKeys = Object?.keys(tableData[0]);
  const columns = columnKeys
    .filter(
      (key) =>
        !excludedKeys.includes(key) && // Exclude keys in excludedKeys
        key.toLowerCase() !== 'id' && // Exclude exact match for "id"
        // `storeName` is camelCase but always wanted, so it bypasses the filter
        (key === 'storeName' || !isCamelCase(key) || allowCamelCase),
    )

    .map((key) => {
      const override = columnOverrides[key] || {};
      const config = { ...columnConfig[key], ...override };
      const isPartyName = key === 'Party';
      if (key.toLowerCase().includes('weight')) {
        config.align = 'center';
        config.textAlign = 'right';
      }
      // if (key === 'S.N.' || key === 'S N') {
      //   return {
      //     title: config?.title || key,
      //     dataIndex: key,
      //     key: key,
      //     align: config.textAlign || 'left',
      //   };
      // }
      const maxWidth = maxLengthoFCellCalcualtor(tableData, key);
      return {
        title: config?.title || key,
        dataIndex: key,
        key: key,
        align: config.textAlign || 'left',
        // ...(key === 'S.N.' || key === 'S N'
        //   ? { width: 0 }
        //   : { width: maxWidth ?? 40 }),
        width:
          override.width ??
          (key === 'S.N.' || key === 'S N ' ? 25 : (maxWidth ?? 40)),
        // width: config?.width || 8 + key.length * 8,
        // width: config?.width,
        ...((config?.title === 'Dr Amount' ||
          config?.title === 'Cr Amount') && {
          onHeaderCell: () => ({ style: { textAlign: 'center' } }),
        }),

        render: (text) => {
          if (Number(text) === 0) {
            return '';
          }
          return (
            <div
              style={{
                lineHeight: '20px',
                textAlign: config.textAlign || 'left',
                wordBreak: isPartyName && 'break-word',
                // whiteSpace: 'nowrap',
                // width: 'max-content',
              }}
            >
              {text}
            </div>
          );
        },
        // onCell: () => ({
        //   style: {
        //     whitespaces: 'no-wrap',
        //     width: 'max-content',
        //   },
        // }),
        // onHeaderCell: () => ({
        //   style: {
        //     whiteSpace: 'nowrap',
        //     width: 'fit-content',
        //   },
        // }),
      };
    });

  return moveStoreAfterAgent(columns);
};

/**
 * The API decides key order, so the Store column can land anywhere. Lists want
 * it directly after the agent — or after the party when a list has no agent
 * column, which is the same slot conceptually.
 */
export const moveStoreAfterAgent = (columns) => {
  const storeIndex = columns.findIndex(
    (column) => column?.dataIndex === 'storeName' || column?.title === 'Store',
  );
  if (storeIndex === -1) return columns;

  const matches = (column, pattern) =>
    pattern.test(String(column?.dataIndex ?? '')) ||
    pattern.test(String(column?.title ?? ''));

  const lastIndexOf = (pattern) => {
    for (let index = columns.length - 1; index >= 0; index -= 1) {
      if (index !== storeIndex && matches(columns[index], pattern))
        return index;
    }
    return -1;
  };

  const agentIndex = lastIndexOf(/agent/i);
  const anchorIndex = agentIndex !== -1 ? agentIndex : lastIndexOf(/party/i);
  if (anchorIndex === -1) return columns;

  const reordered = [...columns];
  const [storeColumn] = reordered.splice(storeIndex, 1);
  const insertAt = storeIndex < anchorIndex ? anchorIndex : anchorIndex + 1;
  reordered.splice(insertAt, 0, storeColumn);

  return reordered;
};

export const generateDynamicColumnsNew = (tableData, excludedKeys = []) => {
  if (!tableData || tableData?.length === 0) return [];

  // Function to check if a string is in camelCase
  const isCamelCase = (key) => /^[a-z]+[A-Z][a-zA-Z]*$/.test(key);

  const columnConfig = {
    itemCode: { align: 'center', textAlign: 'center', title: 'Item Code' },
    orderCode: { align: 'center', textAlign: 'center', title: 'Order Code' },
    referenceItemCode: {
      align: 'center',
      textAlign: 'center',
      title: 'Reference Code',
    },
    stockPurity: { align: 'center', textAlign: 'center', title: 'Purity' },
    setPcs: { align: 'center', textAlign: 'center', title: 'Set Pcs' },

    'S N': { align: 'center', textAlign: 'center' },
    Purchase: { align: 'right', width: 100, textAlign: 'right' },
    purchase: {
      title: 'Purchase',
      align: 'right',
      width: 100,
      textAlign: 'right',
    },
    'Party Name': { align: 'left', textAlign: 'left' },
    Date: { align: 'center', width: 80, textAlign: 'center' },
    'Issue Date': { align: 'center', width: 80, textAlign: 'center' },
    Party: { align: 'left', width: 250, textAlign: 'left' },
    'Agent Name': { align: 'left', width: 250, textAlign: 'left' },
    'Debit (Rs.)': { align: 'right', width: 100, textAlign: 'right' },
    'Credit (Rs.)': { align: 'right', width: 100, textAlign: 'right' },
    'Set Pcs': { align: 'right', width: 100, textAlign: 'right' },
    'Set or Pcs': { align: 'right', width: 100, textAlign: 'right' },
    Purity: { align: 'center', width: 100, textAlign: 'right' },
    'Item Name': { align: 'center', width: 250, textAlign: 'left' },
    grossWeight: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Gross Weight',
    },
    diamondPcs: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Dia. Pcs',
    },
    netWeight: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Net Wt.',
    },

    pureWeight: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Pure Weight',
    },

    sMakingChargeType: {
      align: 'center',
      width: 100,
      textAlign: 'center',
      title: 'S.Making Charge Type',
    },

    sMakingCharge: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'S.Making Charge',
    },

    sMakingAmount: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'S.Making Amt.',
    },

    sWastageType: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'S.Wstg. Type',
    },

    sWastageCharge: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'S.Wstg. Charge',
    },

    sWastageWeight: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'S.Wstg. Wt.',
    },

    sExtraAmount: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'S. Extra Amt.',
    },

    itemSize: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Item Size',
    },

    trayName: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Tray Name',
    },

    karigarName: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Karigar Name',
    },
    itemDescription: {
      align: 'center',
      width: 100,
      textAlign: 'left',
      title: 'Description',
    },
    itemRemarks: {
      align: 'center',
      width: 100,
      textAlign: 'left',
      title: 'Remarks',
    },

    itemMrp: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'MRP Amt.',
    },

    'Weight In Gram': { align: 'center', width: 100, textAlign: 'right' },

    diamondWeight: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Dia. Wt. (Crt)',
    },

    stonePcs: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Stone Pcs',
    },

    weightInGram: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Weight In Gram',
    },

    weightInTola: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Weight In Tola',
    },

    weightInAana: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: 'Weight In Aana',
    },

    'Stone Weight (lal)': { align: 'center', width: 100, textAlign: 'right' },
    'Conv. (lal/gm)': { align: 'center', width: 100, textAlign: 'right' },
    stoneWeight: {
      align: 'center',
      width: 100,
      textAlign: 'right',
      title: `Stone Wt. (${userData?.primaryCalculationType})`,
    },
    'Diamond Weight': { align: 'center', width: 100, textAlign: 'right' },
    'Pure Weight': { align: 'center', width: 100, textAlign: 'right' },
    'Net Amount': { align: 'center', width: 150, textAlign: 'right' },
    'Sales Amount': { align: 'center', width: 150, textAlign: 'right' },

    'Dr Amount': { align: 'center', width: 100, textAlign: 'right' },
    'Cr Amount': { align: 'center', width: 100, textAlign: 'right' },
    'Dr Metal': { align: 'center', width: 100, textAlign: 'right' },
    'Cr Metal': { align: 'center', width: 100, textAlign: 'right' },

    'Cost Rate': { align: 'center', width: 100, textAlign: 'right' },
    MRP: { align: 'center', width: 100, textAlign: 'right' },
    'Issue Cost Amount': { align: 'center', width: 100, textAlign: 'right' },
    'Receive Profit In Wt': { align: 'center', width: 100, textAlign: 'right' },
    'Receive Sales Amount': { align: 'center', width: 100, textAlign: 'right' },
    'Receive profit %': { align: 'center', width: 100, textAlign: 'right' },
    'Receive Gw/Pw': { align: 'center', width: 100, textAlign: 'right' },
    'Issue Gross wt': { align: 'center', width: 100, textAlign: 'right' },
    'Receive Profit In Amount': {
      align: 'center',
      width: 100,
      textAlign: 'right',
    },

    'Gold Rate': { align: 'center', textAlign: 'center' },
    'Silver Rate': { align: 'center', textAlign: 'center' },

    Amount: { align: 'center', width: 100, textAlign: 'right' },
    'Old Value': { align: 'center', width: 100, textAlign: 'right' },
    'New Value': { align: 'center', width: 100, textAlign: 'right' },
    'MRP Amount	': { align: 'left', textAlign: 'left' },

    sn: { title: 'SN', textAlign: 'left', width: 50 },
    item_id: { title: 'Item ID', textAlign: 'left', width: 100 },
    item_name: { title: 'Item Name', textAlign: 'left', width: 150 },
    item_code: { title: 'Item Code', textAlign: 'left', width: 120 },
    show_item_code: { title: 'Item Code', textAlign: 'left', width: 120 },
    purity: { title: 'Purity', textAlign: 'left', width: 80 },
    set_pcs: { title: 'Set/Pcs', textAlign: 'right', width: 80 },
    gross_weight: { title: 'Gross Wt', textAlign: 'right', width: 100 },
    diamond_pcs: { title: 'Diamond Pcs', textAlign: 'right', width: 100 },
    diamond_weight: { title: 'Diamond Wt', textAlign: 'right', width: 100 },
    stone_pcs: { title: 'Stone Pcs', textAlign: 'right', width: 100 },
    stone_weight: { title: 'Stone Wt', textAlign: 'right', width: 100 },
    net_weight: { title: 'Net Wt', textAlign: 'right', width: 100 },
    pure_weight: { title: 'Pure Wt', textAlign: 'right', width: 100 },
    size: { title: 'Size', textAlign: 'left', width: 80 },
  };
  const columnKeys = Object?.keys(tableData[0]);
  const columns = columnKeys
    .filter(
      (key) =>
        !['referenceId', 'redirectUrl', 'itemId', ...excludedKeys].includes(
          key,
        ) && // Exclude keys in excludedKeys
        key.toLowerCase() !== 'id',
    )

    .map((key) => {
      const title = columnConfig[key]?.title || key;
      const config = columnConfig[key] || {};
      const isPartyName = key === 'Party';
      if (key.toLowerCase().includes('weight')) {
        config.align = 'center';
        config.textAlign = 'right';
      }
      const maxWidth = maxLengthoFCellCalcualtor(tableData, key);
      return {
        title: title,
        dataIndex: key,
        key: key,
        align: config.textAlign || 'left',
        width: key === ('S.N.' || 'S N ') ? 25 : (maxWidth ?? 40),

        render: (text) => {
          if (Number(text) === 0) {
            return '';
          }
          return (
            <div
              style={{
                lineHeight: '20px',
                textAlign: config.textAlign || 'left',
                wordBreak: isPartyName && 'break-word',
                // whiteSpace: 'nowrap',
                // width: 'max-content',
              }}
            >
              {text}
            </div>
          );
        },
        // onCell: () => ({
        //   style: {
        //     whitespaces: 'no-wrap',
        //     width: 'max-content',
        //   },
        // }),
        // onHeaderCell: () => ({
        //   style: {
        //     whiteSpace: 'nowrap',
        //     width: 'fit-content',
        //   },
        // }),
      };
    });

  return columns;
};

export const generateDynamicColumnsIrdAnnex = (
  tableData,
  excludedKeys = [],
) => {
  if (!tableData || tableData?.length === 0) return [];

  // Function to check if a string is in camelCase
  const isCamelCase = (key) => /^[a-z]+[A-Z][a-zA-Z]*$/.test(key);

  const columnConfig = {
    itemCode: { align: 'center', textAlign: 'center', title: 'Item Code' },
    orderCode: { align: 'center', textAlign: 'center', title: 'Order Code' },

    'S N': { align: 'center', textAlign: 'center' },
    Purchase: { align: 'right', width: 100, textAlign: 'right' },

    financial_year: {
      align: 'right',
      width: 100,
      textAlign: 'center',
      title: 'Financial Year',
    },

    bill_no: {
      align: 'right',
      width: 100,
      textAlign: 'center',
      title: 'Bill No.',
    },

    sales_bill_no: {
      align: 'right',
      width: 100,
      textAlign: 'center',
      title: 'Sales Bill No.',
    },

    customer_name: {
      width: 100,
      title: 'Customer Name',
    },

    customer_pan: {
      width: 100,
      textAlign: 'center',
      title: 'Customer PAN',
    },

    bill_date: {
      width: 100,
      textAlign: 'center',
      title: 'Bill Date',
    },

    amount: {
      width: 100,
      align: 'center',
      textAlign: 'right',
      title: 'Amount',
    },

    discount: {
      width: 100,
      align: 'center',
      textAlign: 'right',
      title: 'Discount',
    },

    taxable_amount: {
      width: 100,
      align: 'center',
      textAlign: 'right',
      title: 'Taxable Amount',
    },

    tax_amount: {
      width: 100,
      align: 'center',
      textAlign: 'right',
      title: 'Tax Amount',
    },

    vat_amount: {
      width: 100,
      align: 'center',
      textAlign: 'right',
      title: 'VAT Amount',
    },

    net_amount: {
      width: 100,
      align: 'center',
      textAlign: 'right',
      title: 'Net Amount',
    },

    sync_with_ird: {
      width: 100,
      align: 'center',
      textAlign: 'center',
      title: 'Sync With Ird',
    },

    is_bill_active: {
      width: 100,
      align: 'center',
      textAlign: 'center',
      title: 'Is Bill Active',
    },

    entered_by: {
      width: 100,
      align: 'center',
      title: 'Entered By',
    },

    is_realtime: {
      width: 100,
      align: 'center',
      textAlign: 'center',
      title: 'Is Realtime',
    },

    created_time: {
      width: 100,
      align: 'center',
      textAlign: 'center',
      title: 'Created At',
    },

    print_count: {
      width: 100,
      align: 'center',
      textAlign: 'right',
      title: 'Print Count',
    },

    print_time: {
      width: 100,
      align: 'center',
      textAlign: 'center',
      title: 'Printed Time',
    },

    print_by: {
      width: 100,
      title: 'Printed By',
    },

    sync_message: {
      // width: 100,
      align: 'left',
      textAlign: 'left',
      title: 'Sync Message',
    },
  };
  const columnKeys = Object?.keys(tableData[0]);
  const columns = columnKeys
    .filter(
      (key) =>
        !['referenceId', 'redirectUrl', 'itemId', ...excludedKeys].includes(
          key,
        ) && // Exclude keys in excludedKeys
        key.toLowerCase() !== 'id',
    )

    .map((key) => {
      const title = columnConfig[key]?.title || key;
      const config = columnConfig[key] || {};
      const isPartyName = key === 'Party';
      if (key.toLowerCase().includes('weight')) {
        config.align = 'center';
        config.textAlign = 'right';
      }
      const maxWidth = maxLengthoFCellCalcualtor(tableData, key);
      return {
        title: title,
        dataIndex: key,
        key: key,
        align: config.textAlign || 'left',
        width: key === ('S.N.' || 'S N ') ? 25 : (maxWidth ?? 40),

        // render: (text) => {
        //   if (Number(text) === 0) {
        //     return '';
        //   }
        //   return (
        //     <div
        //       style={{
        //         lineHeight: '20px',
        //         textAlign: config.textAlign || 'left',
        //         wordBreak: isPartyName && 'break-word',
        //       }}
        //     >
        //       {text}
        //     </div>
        //   );
        // },

        render: (text) => {
          let displayText = text;

          if (typeof text === 'boolean') {
            displayText = text ? 'True' : 'False';
          } else if (Number(text) === 0 && key !== 'print_count') {
            displayText = '';
          }

          return (
            <div
              style={{
                lineHeight: '20px',
                textAlign: config.textAlign || 'left',
                wordBreak: isPartyName && 'break-word',
              }}
            >
              {displayText}
            </div>
          );
        },
      };
    });

  return columns;
};

// export const transformColumnsToHierarchy = (tableData) => {
//   if (!tableData.length) return [];

//   const columnSet = new Set();
//   tableData.forEach((row) =>
//     Object.keys(row).forEach((key) => columnSet.add(key)),
//   );

//   const groupedColumns = {};
//   columnSet.forEach((key) => {
//     const parts = key.split(' ');
//     let parentKey = parts[0].toLowerCase();
//     const childKey = parts.slice(1).join(' '); // Remove prefix

//     // Rename "Work" to "Work In Progress"
//     if (parentKey === 'work') {
//       parentKey = 'Work In Progress';
//     } else {
//       parentKey = parentKey.charAt(0).toUpperCase() + parentKey.slice(1); // Capitalize other groups
//     }

//     if (['Issue', 'Work In Progress', 'Sales'].includes(parentKey)) {
//       if (!groupedColumns[parentKey]) {
//         groupedColumns[parentKey] = { title: parentKey, children: [] };
//       }
//       groupedColumns[parentKey].children.push({
//         title: childKey,
//         dataIndex: key,
//         width: 10 + childKey.length * 8,
//         key,
//       });
//     } else {
//       groupedColumns[key] = {
//         title: key,
//         dataIndex: key,
//         key,
//         width: 10 + key.length * 8,
//       };
//     }
//   });

//   return Object.values(groupedColumns);
// };

function isSnakeCase(str) {
  return /^[a-z]+(?:_[a-z0-9]+)*$/.test(str);
}
export const transformColumnsToHierarchy = (tableData) => {
  if (!tableData.length) return [];

  const columnSet = new Set();
  tableData?.forEach((row) =>
    Object.keys(row).forEach((key) => columnSet.add(key)),
  );

  const columnConfig = {
    'issue Gross Weight': { align: 'center', width: 100, textAlign: 'right' },
    'issue Customer': { align: 'center', width: 250, textAlign: 'left' },
    'Issue Remaining Days': { align: 'center', textAlign: 'right' },
    'work Receive Gwt.': { align: 'center', width: 100, textAlign: 'right' },
    'issue Item Name': { align: 'center', width: 200, textAlign: 'left' },
    'issue Remaining Days': { align: 'center', width: 200, textAlign: 'right' },
    order_date: {
      title: 'Order Date',
      dataIndex: 'order_date',
      key: 'order_date',
    },
    order_bill_no: {
      title: 'Order Bill No',
      dataIndex: 'order_bill_no',
      key: 'order_bill_no',
    },
    order_entry_no: {
      title: 'Order Entry No',
      dataIndex: 'order_entry_no',
      key: 'order_entry_no',
    },
    order_customer_name: {
      title: 'Customer Name',
      dataIndex: 'order_customer_name',
      key: 'order_customer_name',
    },
    item_name: {
      title: 'Item Name',
      dataIndex: 'item_name',
      key: 'item_name',
    },
    order_item_code: {
      title: 'Item Code',
      dataIndex: 'order_item_code',
      key: 'order_item_code',
    },
    order_gross_weight: {
      title: 'Gross Weight',
      dataIndex: 'order_gross_weight',
      key: 'order_gross_weight',
      align: 'right',
    },
    order_delivery_date: {
      title: 'Delivery Date',
      dataIndex: 'order_delivery_date',
      key: 'order_delivery_date',
    },
    order_remaining_days: {
      title: 'Remaining Days',
      dataIndex: 'order_remaining_days',
      key: 'order_remaining_days',
      align: 'center',
    },
    issue_karigar_name: {
      title: 'Karigar Name',
      dataIndex: 'issue_karigar_name',
      key: 'issue_karigar_name',
    },
    issue_date: {
      title: 'Issue Date',
      dataIndex: 'issue_date',
      key: 'issue_date',
    },
    receive_date: {
      title: 'Receive Date',
      dataIndex: 'receive_date',
      key: 'receive_date',
    },
    receive_gross_weight: {
      title: 'Receive Gross Weight',
      dataIndex: 'receive_gross_weight',
      key: 'receive_gross_weight',
      align: 'right',
    },
    sales_date: {
      title: 'Sales Date',
      dataIndex: 'sales_date',
      key: 'sales_date',
    },
    sales_party_name: {
      title: 'Sales Party',
      dataIndex: 'sales_party_name',
      key: 'sales_party_name',
    },
    sales_bill_no: {
      title: 'Sales Bill No',
      dataIndex: 'sales_bill_no',
      key: 'sales_bill_no',
    },
    sales_entry_no: {
      title: 'Sales Entry No',
      dataIndex: 'sales_entry_no',
      key: 'sales_entry_no',
    },
    exchange_item_name: {
      title: 'Exchange Item',
      dataIndex: 'exchange_item_name',
      key: 'exchange_item_name',
    },
    exchange_item_code: {
      title: 'Exchange Code',
      dataIndex: 'exchange_item_code',
      key: 'exchange_item_code',
    },
    // Add more as needed
  };

  const groupedColumns = {};
  columnSet.forEach((key) => {
    const parts = isSnakeCase(key) ? key.split('_') : key.split(' ');
    let parentKey = parts[0].toLowerCase();
    const childKeyRaw = parts.slice(1).join(' '); // Remove prefix
    const childKey = childKeyRaw.charAt(0).toUpperCase() + childKeyRaw.slice(1); // Capitalize first letter

    // Rename "Work" to "Work In Progress"
    if (parentKey === 'work') {
      parentKey = 'Work In Progress';
    } else {
      parentKey = parentKey.charAt(0).toUpperCase() + parentKey.slice(1);
    }

    const config = columnConfig[key] || {};

    if (
      ['Issue', 'Work In Progress', 'Sales', 'Exchange', 'Receive'].includes(
        parentKey,
      )
    ) {
      if (!groupedColumns[parentKey]) {
        groupedColumns[parentKey] = {
          title: parentKey,
          key: parentKey,
          children: [],
        };
      }

      groupedColumns[parentKey].children.push({
        title: childKey,
        dataIndex: key,
        key,
        align: config.align || 'center',
        width: config.width || 10 + childKey.length * 8,
        render: (text) => {
          return (
            <div
              style={{
                lineHeight: '20px',
                textAlign: config.textAlign || 'left',
              }}
            >
              {text}
            </div>
          );
        },
      });
    } else {
      groupedColumns[key] = {
        title: config.title || key,
        dataIndex: key,
        key,
        align: config.align || 'left',
        width: config.width || 10 + key.length * 8,
        render: (text) => (
          <div
            style={{ lineHeight: '20px', textAlign: config.align || 'left' }}
          >
            {text}
          </div>
        ),
      };
    }
  });

  return Object.values(groupedColumns);
};

export const handleDateChange = (dates, setStartDate, setEndDate) => {
  if (dates && dates.length > 0) {
    const formattedStartDate = dates[0].format('YYYY-MM-DD');
    const formattedEndDate = dates[1].format('YYYY-MM-DD');
    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);
  }
};

export const transformColumns = (columns) => {
  if (!columns?.length) return [];
  const groups = {
    Receive: [],
    Issue: [],
    Balance: [],
  };

  const otherColumns = [];

  columns.forEach((col) => {
    const title = col.title;

    if (title.startsWith('Receive')) {
      groups.Receive.push({
        ...col,
        title: title.replace('Receive ', ''),
        width: 100,
        align: 'center',
        render: (text) => {
          if (Number(text) === 0) {
            return '';
          } else {
            return (
              <div
                style={{
                  lineHeight: '20px',
                  textAlign: 'right',
                }}
              >
                {text}
              </div>
            );
          }
        },
        // className: '!tw-bg-[#ffe0b2ab] !tw-text-[#666666]',
        className: 'receive',
      });
    } else if (title.startsWith('Issue')) {
      groups.Issue.push({
        ...col,
        title: title.replace('Issue ', ''),
        width: 100,
        align: 'center',
        render: (text) => {
          if (Number(text) === 0) {
            return '';
          } else {
            return (
              <div
                style={{
                  lineHeight: '20px',
                  textAlign: 'right',
                }}
              >
                {text}
              </div>
            );
          }
        },
        // className: '!tw-bg-[#fff9c4ab] !tw-text-[#666666]',
        className: 'issue',
      });
    } else if (title.startsWith('Balance')) {
      groups.Balance.push({
        ...col,
        title: title.replace('Balance ', ''),
        width: 100,
        align: 'center',
        render: (text) => {
          if (Number(text) === 0) {
            return '';
          } else {
            return (
              <div
                style={{
                  lineHeight: '20px',
                  textAlign: 'right',
                }}
              >
                {text}
              </div>
            );
          }
        },
        // className: '!tw-bg-[#d2ecd6ab] !tw-text-[#666666]',
        className: 'balance',
      });
    } else {
      otherColumns.push(col);
    }
  });
  const stockLedgerReportCols = [
    ...otherColumns,
    ...Object.keys(groups).map((groupName) => ({
      title: groupName,
      children: groups[groupName],
      className: (() => {
        switch (groupName) {
          case 'Issue':
            // return '!tw-bg-[#fff9c4ab] !tw-text-[#666666]';
            return 'issue';
          case 'Receive':
            // return '!tw-bg-[#ffe0b2ab] !tw-text-[#666666]';
            return 'receive';
          case 'Balance':
            // return '!tw-bg-[#d2ecd6ab] !tw-text-[#666666]';
            return 'balance';
          default:
            return '';
        }
      })(),
    })),
  ];
  return stockLedgerReportCols;
};

export function maxLengthoFCellCalcualtor(tableData, key) {
  const tableDataArray = tableData?.map((item) => (item[key] ? item[key] : ''));
  const tableDataLengthArray = tableData?.map((item) =>
    item[key] ? item[key]?.toLocaleString().length : 0,
  );
  const maxLengthOfTableData = Math.max(...tableDataLengthArray);
  const keyLength =
    typeof key === 'string' ? key?.length : key?.toLocaleString().length;

  const totalLength = reportCalculateTotalsLength(tableDataArray, key);
  const maxLength = Math.max(keyLength, maxLengthOfTableData, totalLength);

  return maxLength > 10 ? maxLength * 8 : maxLength * 10;
}
export function maxLengthoFCellCalcualtorWithoutTotal(tableData, key) {
  const tableDataArray = tableData?.map((item) => (item[key] ? item[key] : ''));
  const tableDataLengthArray = tableData?.map((item) =>
    item[key] ? item[key]?.toLocaleString().length : 0,
  );
  const maxLengthOfTableData =
    tableDataLengthArray?.length > 0 ? Math.max(...tableDataLengthArray) : 0;
  const keyLength =
    typeof key === 'string' ? key?.length : key?.toLocaleString().length;

  const maxLength = Math.max(keyLength, maxLengthOfTableData);

  return maxLength > 10 ? maxLength * 8 : maxLength * 10;
}
